import { useLocation } from "react-router-dom";

const useQueryString = () => {
  const location = useLocation();
  const qs = location.search.substring(1); //omit leading '?' character

  let qs_dict = {};
  for (let kv of qs.split("&")) {
    const kva = kv.split("=");
    qs_dict[kva[0]] = kva[1];
  }

  return qs_dict;
};

const toUTCDateString = (date) => {
  let dateString = date.toISOString().split(".");
  return `${dateString[0]}Z`;
};

export default {
  useQueryString,
  toUTCDateString,
};
